import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { ComponentRegistry } from 'core';
import { goBack } from 'core/routing';
import { staticURL } from 'core/url';

import { Wizard } from 'libs/wizards/index';
import DocumentHead from 'legacyComponents/documentHead';

import { ProjectTypeOption } from 'apps/project/views/projectTypeOption';
import { ProjectTypeItem } from 'apps/project/views/projectTypeItem';
import { NewProjectAppManager } from 'apps/project/newProject/appManager';
// import { clientStore } from 'apps/client/app';
import { useAppManager } from 'core/hooks';

import Button from 'components/Button';
import Image from 'components/Image';
import {
  MainSignInPageWrapper,
  ImageWrapper,
  GoBackWrapper,
  WrapperSignInForm,
  MainSignInFormColumn,
} from 'apps/signIn/styles';

import Logo from 'components/Logo';

ComponentRegistry.add('project.projectTypeOption', ProjectTypeOption);
ComponentRegistry.add('project.projectTypeItem', ProjectTypeItem);

const NewProject = observer(props => {
  // UNSAFE_componentWillMount() {
  //   if (clientStore.signedInProfile) {
  //     this.appManager = new NewProjectAppManager(null, {});
  //   } else {
  //     clientStore.routerStore.navigate(
  //       'home.signIn',
  //       {
  //         next: clientStore.next(),
  //       },
  //       {
  //         replace: true,
  //       },
  //     );
  //   }
  // }

  const appManager = useAppManager(NewProjectAppManager);
  const { t } = props;
  if (!appManager) {
    return null;
  }
  return (
    <>
      <DocumentHead title={`${t('New Project')}`} index='noindex' />
      <MainSignInPageWrapper>
        <GoBackWrapper>
          <Button
            outline
            variant='minimal'
            icon='close_small'
            size='small'
            onClick={() => goBack()}
          />
        </GoBackWrapper>
        <ImageWrapper>
          <Image
            src={staticURL('assets/gridImages/yellow-triangle.svg')}
            alt='Grid image'
          />
        </ImageWrapper>
        <WrapperSignInForm>
          <MainSignInFormColumn>
            <Logo size='48px' />
            <Wizard isSideBarForm spacing='medium' wizard={appManager.wizard} />
          </MainSignInFormColumn>
        </WrapperSignInForm>
      </MainSignInPageWrapper>
    </>
  );
});

NewProject.propTypes = {
  t: PropTypes.func,
};

export default withNamespaces()(NewProject);
